import { render, staticRenderFns } from "./SkillModal.vue?vue&type=template&id=f6af5752&"
import script from "./SkillModal.vue?vue&type=script&lang=js&"
export * from "./SkillModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6af5752')) {
      api.createRecord('f6af5752', component.options)
    } else {
      api.reload('f6af5752', component.options)
    }
    module.hot.accept("./SkillModal.vue?vue&type=template&id=f6af5752&", function () {
      api.rerender('f6af5752', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/SkillModal.vue"
export default component.exports